import { render, staticRenderFns } from "./QueueDetails.vue?vue&type=template&id=1dfbe0b7&"
import script from "./QueueDetails.vue?vue&type=script&lang=js&"
export * from "./QueueDetails.vue?vue&type=script&lang=js&"
import style0 from "./QueueDetails.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VChip,VMain})
